import { Directive, output, inject } from '@angular/core';
import { V2DropdownComponent } from './v2-dropdown.component';
import { TinyHelpers } from '@coin/shared/core/util-helpers';

/** Adds a built-in scroll functionality to `coin-v2-dropdown` */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'coin-v2-dropdown[scrollEndReached]',
  standalone: true,
  exportAs: 'dropdownScroll'
})
export class DropdownScrollDirective<T> {
  private v2DropdownComponent = inject<V2DropdownComponent<T>>(V2DropdownComponent);

  scrollEndReached = output<void>();

  private lastScrollTop = 0;
  private prevScrolledOverVerticalBound: boolean;

  constructor() {
    this.listenToOpenedChange();
  }

  private listenToOpenedChange(): void {
    this.v2DropdownComponent.openedChange.subscribe(opened => {
      if (opened) {
        this.registerScrollListener();
      } else {
        this.removeScrollListener();
      }
    });
  }

  private registerScrollListener(): void {
    const panel = document.querySelector('.mat-mdc-select-panel');
    this.lastScrollTop = 0;
    panel?.addEventListener('scroll', this.onScroll);
  }

  private removeScrollListener(): void {
    const panel = document.querySelector('.mat-mdc-select-panel');
    panel?.removeEventListener('scroll', this.onScroll);
  }

  private onScroll = (event: WheelEvent) => {
    const scrolledOverVerticalBound = TinyHelpers.scrolledOverVerticalBound(event, this.lastScrollTop, 0.99);
    if (scrolledOverVerticalBound && !this.prevScrolledOverVerticalBound) {
      this.scrollEndReached.emit();
    }
    this.prevScrolledOverVerticalBound = scrolledOverVerticalBound;
  };
}
